import { useEffect } from 'react';
import Script from 'next/script';

export default function LCPTracker() {
    useEffect(() => {
        const observer = new PerformanceObserver((list) => {
            list.getEntries().forEach((entry : any) => {
                console.log(entry, 'oikdijwdijdwij');
                if (entry.entryType === 'largest-contentful-paint') {
                    // Send the LCP value to your analytics or logging service
                    console.log("Largest Contentful Paint (LCP):", entry.renderTime || entry.loadTime);
                }
            });
        });

        // Observe the 'largest-contentful-paint' entry type
        observer.observe({ type: 'largest-contentful-paint', buffered: true });

        return () => {
            observer.disconnect();
        };
    }, []);

    return (
        <Script
            id="lcp-tracker"
            strategy="beforeInteractive"
            src="/empty.js"
        />
    );
}